import Typography from '@mui/material/Typography'
import { ThemeProvider } from '@emotion/react'

import theme from '@/Theme'

import { Row } from '@/Components/Layout/Row'

export enum Environments {
  Staging = 'staging',
  Development = 'development',
  Production = 'production'
}

const EnvBanner = ({ env }: { env: Environments }) => {
  if (env === Environments.Production) {
    return null
  }

  let sx = {
    backgroundColor: 'info.main',
    color: 'info.contrastText'
  }
  if (env === Environments.Staging) {
    sx = {
      backgroundColor: 'warning.main',
      color: 'warning.contrastText'
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Row
        component="header"
        sx={{
          ...sx,
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          p: 1
        }}
      >
        <Typography sx={{ textTransform: 'uppercase' }}>{env}</Typography>
      </Row>
    </ThemeProvider>
  )
}

export default EnvBanner
